module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MyShareView.js"));
	}, "MyShareView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyShareView!./src/pages/Shop/Visitor/MyShare/MyShareView.js
// module id = 888
// module chunks = 438